import styles from './FJBrushCard.module.less';
import classNames from 'classnames';
import FJEraseIcon from '../../../assets/svg/erase.svg?react';
import FJDrawIcon from '../../../assets/svg/draw.svg?react';
import { useState, useRef, useMemo } from 'react';
import FJConfig from '../../../config/FJConfig';
import FJSwitchButton from '../FJSwitchButton/FJSwitchButton';
import FJHoverBoardGradation from '../FJHoverBoard/FJHoverBoardGradation';
import FJValueInput from '../FJValueInput/FJValueInput';
import { MOUSE_EVENT_TYPE } from '../../../components/FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import FJSlider from '../FJSlider/FJSlider';
import FJLocalStore from '../../../store/FJLocalStore';
import FJAppConstant from '../../../constants/FJAppConstant';

const MAX_SIZE = 100;
const MIN_SIZE = 2;

const FJBrushCard = props => {
    const {
        active,
        disabled,
        brashSize = 0,
        curBrushType,
        title = 'ai-scratch-fold-restoration',

        minBrashSize = MIN_SIZE,
        maxBrashSize = MAX_SIZE,

        isMouseMove,
        isSlideCompare,
        isShowSwitch = true,
        isShowVideoTips = true,
        eraseTipsBoxStyle,

        changeBrushType,
        changeActive,
        changeBrashSize,
    } = props;

    const [isEraseHover, setIsEraseHover] = useState(false);
    const eraseEditBtnRef = useRef(null);

    const tipsPosition = useMemo(() => {
        if (eraseEditBtnRef.current) {
            const rect = eraseEditBtnRef.current.getBoundingClientRect();
            return {
                top: rect.top - 70 - 218 - 8,
                left: rect.left + rect.width / 2,
            };
        }
        return {};
    }, [isEraseHover]);

    const isObjectErase = FJConfig.appType === FJAppConstant.OBJECT_ERASER;
    return (
        <div
            className={classNames(styles.container, !active && styles.hide, disabled && styles.disabled, {
                [styles.object_erase_container]: isObjectErase,
            })}
        >
            <div className={classNames(styles.switch_card)}>
                <div className={styles.text}>{FJLocalStore._(title)}</div>
                {isShowSwitch && <FJSwitchButton active={active} onChange={changeActive} />}
            </div>
            <div className={classNames(styles.edit_box, !active && styles.hide)}>
                <div className={styles.btu_box}>
                    <div
                        className={styles.erase_edit_btn_box}
                        ref={eraseEditBtnRef}
                        onMouseEnter={() => setIsEraseHover(true)}
                        onMouseLeave={() => setIsEraseHover(false)}
                    >
                        <FJHoverBoardGradation
                            className={classNames(styles.edit_btn, {
                                [styles.edit_btn_hover]: !(
                                    curBrushType === MOUSE_EVENT_TYPE.MASK_DRAW &&
                                    !isMouseMove &&
                                    !isSlideCompare
                                ),
                            })}
                            contentClassName={styles.btn}
                            active={curBrushType === MOUSE_EVENT_TYPE.MASK_DRAW && !isMouseMove && !isSlideCompare}
                            onClick={() => changeBrushType(MOUSE_EVENT_TYPE.MASK_DRAW)}
                        >
                            <FJDrawIcon className={styles.draw_icon} />
                            <span className={styles.btn_text}>{FJLocalStore._('draw')}</span>
                        </FJHoverBoardGradation>
                    </div>

                    <FJHoverBoardGradation
                        className={classNames(styles.edit_btn, {
                            [styles.edit_btn_hover]: !(
                                curBrushType === MOUSE_EVENT_TYPE.MASK_ERASE &&
                                !isMouseMove &&
                                !isSlideCompare
                            ),
                        })}
                        contentClassName={styles.btn}
                        active={curBrushType === MOUSE_EVENT_TYPE.MASK_ERASE && !isMouseMove && !isSlideCompare}
                        onClick={() => changeBrushType(MOUSE_EVENT_TYPE.MASK_ERASE)}
                    >
                        <FJEraseIcon className={styles.erase_icon} />
                        <span className={styles.btn_text}>{FJLocalStore._('erase')}</span>
                    </FJHoverBoardGradation>
                </div>

                <div className={styles.slider_box}>
                    <div className={styles.slider_text}>
                        <div className={styles.slider_text_item}>{FJLocalStore._('size')}</div>
                        <FJValueInput
                            max={maxBrashSize}
                            min={minBrashSize}
                            value={brashSize}
                            changeValue={changeBrashSize}
                            className={styles.slider_input}
                        />
                    </div>
                    <FJSlider
                        className={styles.slider}
                        max={maxBrashSize}
                        min={minBrashSize}
                        value={brashSize}
                        thumbSize={18}
                        onChange={changeBrashSize}
                    />
                </div>

                {isShowVideoTips && (
                    <div
                        className={classNames(styles.erase_tips_box, {
                            [styles.show]: isEraseHover,
                        })}
                        style={{ ...eraseTipsBoxStyle, ...tipsPosition }}
                    >
                        <div className={styles.video_box}>
                            <video className={styles.video} src={FJConfig.eraseTipsVideoUrl} autoPlay muted loop />
                        </div>
                        <div className={styles.text_box}>{FJLocalStore._('erase-tips')}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FJBrushCard;
